import { formatCargoLabel } from "modules/PortPredictor/components/portPredictorFormatCargoLabelHelper"
import { VesselStay } from "../hooks/useFetchVesselStays"
import moment from "moment"
import { OverlayTrigger, Popover } from "react-bootstrap"
import Tooltip from "react-bootstrap/Tooltip"
import { useEffect, useState } from "react"

const renderTooltip = () => {
  return (
    <Popover id="popover-basic">
      <Popover.Body>Cargo is estimated</Popover.Body>
    </Popover>
  )
}

export function PrevetLastFiveCargoes({
  vesselStaysData,
}: {
  vesselStaysData: VesselStay[]
}) {
  const lastFiveStaysWithCargoes = vesselStaysData
    .filter((stay) => stay.cargo !== null)
    .slice(0, 5)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth)
    }

    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  function truncateCargo(cargoName: string, maxLength = 5) {
    // Truncate only if screen width is below 760px (mobile)
    if (screenWidth < 760) {
      return cargoName
    }
    // Don't truncate if screen width is 2140px or above, or below 1660px
    if (screenWidth >= 2140 || screenWidth < 1200) {
      return cargoName
    } else {
      return cargoName.length > maxLength
        ? `${cargoName.slice(0, maxLength)}...`
        : cargoName
    }
  }

  return (
    <div>
      <div className="d-flex border-bottom">
        <h4 className="card-title ">Last 5 Cargoes</h4>

        <OverlayTrigger placement="top" overlay={renderTooltip()}>
          <i
            className="ti-info-alt ms-1"
            style={{ position: "relative", fontSize: "0.65rem" }}
          />
        </OverlayTrigger>
        {lastFiveStaysWithCargoes.length < 5 &&
          lastFiveStaysWithCargoes.length > 0 && (
            <div className="ms-2">
              (Only {lastFiveStaysWithCargoes.length} Shipments)
            </div>
          )}
      </div>
      <div className="mt-3">
        {lastFiveStaysWithCargoes.length === 0 ? (
          <>
            <div className="text-muted">No last cargo found</div>
          </>
        ) : (
          lastFiveStaysWithCargoes.map((stay, i) => {
            return (
              <div
                key={`${stay.cargo}_${stay.date_from}`}
                className="d-flex justify-content-between"
              >
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-${stay.cargo}_${stay.date_from}`}>
                      {formatCargoLabel(stay.cargo as string)}
                    </Tooltip>
                  }
                >
                  <div style={{ cursor: "pointer" }}>
                    <span>{i + 1}. </span>
                    {truncateCargo(formatCargoLabel(stay.cargo as string))}
                  </div>
                </OverlayTrigger>
                <div className="hide-on-small-screen">
                  {moment(stay.date_from).format("MMM [']YY")}
                </div>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}
